// Auto-generated by set-version.js
export const buildInfo = {
  version: '1.0.0',
  hash: 'TEMP-YXIAEI',
  builtAt: '2026-11-05T09:58:46.964Z'
};
